import { computed, watch } from 'vue';
import {
  useActiveMenu,
  useMenuSection,
} from '@/utils/composables/useMenuSection';
import { useResizableLeftMenu } from '@/utils/composables/useResizableLeftMenu';
import { userSession } from '@/utils/userSession';

/** 新レイアウトの左メニューの状態（幅の永続化・画面ごとの開閉ルール）をまとめる */
export const useLeftMenuLayout = () => {
  const {
    panelWidth,
    isDragging,
    toggle,
    startDrag,
    expandWithoutPersisting,
    restorePersistedWidth,
  } = useResizableLeftMenu(
    userSession.getLeftMenuPanelWidth,
    userSession.setLeftMenuPanelWidth,
  );

  const section = useMenuSection();
  const hasPanel = computed(() => {
    return section.value !== undefined && section.value !== 'notifications';
  });
  const activeMenu = useActiveMenu();

  watch(section, (newSection, oldSection) => {
    if (oldSection !== 'search' && newSection === 'search') {
      // 別画面から検索画面に遷移する際にはメニューを開くように設定
      expandWithoutPersisting();
    } else if (oldSection === 'search' && newSection !== 'search') {
      // 検索画面から別画面に遷移する際には保存されている幅に戻す
      restorePersistedWidth();
    }
  });

  return {
    panelWidth,
    hasPanel,
    isDragging,
    toggle,
    startDrag,
    activeMenu,
  };
};
